import { useCallback } from 'react';
import { React, useState, Fragment } from "react";
import DetailCard from "./DetailCard";
import { useRef, useEffect } from 'react';
import { Button } from "../../components/EmailAutomation/components/Button";
import { Input } from "../../components/EmailAutomation/components/Input";
import { ChevronLeft, Copy, ExternalLink, X, Tag, Users, Clock, File, Share2, Link as LinkIcon, Video, Grid3x3, List, Download, FolderInput, Trash2, FolderOpen, Facebook, Instagram, Loader2 } from 'lucide-react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import "./cardDetail.scss";
import "@fortawesome/free-solid-svg-icons";

import { Dialog, Transition } from "@headlessui/react";
import moment from "moment";
import "../../components/Bookmarks/Bookmarks.scss";








import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import services from "../../API";
import parse from "html-react-parser";





import youtubeIcon from "../../assets/images/youtube.svg";
import tiktokIcon from "../../assets/images/download-tiktok.png";

import twitterlogo from "../../assets/images/twitternewlogo.svg";

import audienceIcon from "../../assets/icons/Audience.jpg";
import messengerIcon from "../../assets/icons/FacebookMessenger.png";
import { toastify } from "../../components/Toast";
import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import "./Paragraph";
import "./Paragraphs";
import "./Fparagraph";
import "./PostContent";
// import DownloadButton from '../../assets/icons/orangeDownload.svg';

// import LandingPage from '../../assets/images/landingPage.png';

import LandingPageNoPreview from "../../assets/images/Landing-page-No-preview-image.png";

import "./Sliderpopup.js";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";




// import resizeIcon from "../../assets/icons/resizeIcon.svg";
import BlackDismiss from "../../assets/icons/dismissButton.svg";
import ShareCard from "./shareCard";
import "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";





import "react-awesome-spinners";
// import { faClose } from "@fortawesome/free-solid-svg-icons";

const getCardMedia = (card) => {
  const mediaItems = Array.isArray(card?.content?.imageUrl) ? card.content.imageUrl : [];
  const primaryMedia = mediaItems[0];
  const videoMedia = mediaItems.find((item) =>
    item?.urlType?.toLowerCase() === "video" ||
    /\.(mp4|mov|webm)(?:[?#]|$)/i.test(item?.url || "")
  );
  const isVideo =
    card?.cardType?.toLowerCase() === "video" ||
    card?.adData?.["Format"]?.toLowerCase() === "video" ||
    Boolean(videoMedia);
  const selectedMedia = isVideo ? videoMedia || primaryMedia : primaryMedia;
  const mediaUrl = isVideo
    ? selectedMedia?.url
    : selectedMedia?.metaData?.defaultImage || selectedMedia?.url;

  return { mediaUrl, isVideo: Boolean(isVideo && selectedMedia?.url) };
};



function CardDetail() {
  const navigate = useNavigate();
  const [subBucket, setSubBucket] = useState([]);
  const [code, setCode] = useState("");

  // Theme resolution for system mode
  const resolveTheme = (val) => {
    if (val === "system" || !val) {
      return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    }
    return val;
  };
  const [appTheme, setAppTheme] = useState(resolveTheme(localStorage.getItem("theme")));
  const [isLoading, setIsLoading] = useState(true);
  useState(false);
  const [popup, setPopup] = useState(false);
  useState(false);
  useState("");
  useState(false);
  const [isPlaying, ] = useState(false);
  const [isPlayingPopup, ] = useState(false);
  const [openMove, setOpenMove] = useState(false);
  const [searchBucket, setSearchBucket] = useState("");
  useState(0);
  useState(false);
  const [, setIsBucketOpen] = useState(false);
  useState(true);
  const [bucketCreated, setBucketCreated] = useState(false);
  const [isTagOpen, setIsTagOpen] = useState(false);
  const [optionSelect, setOptionSelect] = useState("");
  const [openCopy, setOpenCopy] = useState(false);
  useState("");
  const cardId = useParams();
  const [buckets, setBuckets] = useState([]);
  const [selectedBucket, setSelectedBucket] = useState("");
  useState(null);
  const [sourceUrl, setSourceUrl] = useState("");
  const [tagOptions, setTagOptions] = useState([]);
  const [inputValueSet, setInputValueSet] = useState("");
  const [, setImageUrl] = useState("");
  let [isOpenss, setIsOpens] = useState(false);
  const [, setFetchingCard] = useState(false);
  useState(true);
  const [, setStarCard] = useState(false);
  const [BucketSharePopup, setBucketSharePopup] = useState(false);
  const [shareBucketId, setShareBucketId] = useState("");
  useState("");
  const [tags, setTags] = useState([]);
  const [mainBucket, setMainBucket] = useState({});
  const [, setBookmarkRestrict] = useState(false);
  const [, setFileRestrict] = useState(false);
  const [intervalState, setIntervalState] = useState(false);
  const [, setSharedPermission] = useState("");
  const [, setUserPermission] = useState("");
  const [, setSharedToken] = useState("");
  useState(true);

  const [, setImageSrc] = useState(null);
  const [, setTagswidth] = useState("tagname-tagsinput");
  const [, setOpenCopyLink] = useState(false);
  const [, setPublicUrl] = useState("");
  const [iOS, ] = useState(/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);

  const [activeTab, setActiveTab] = useState("details");
  const [transcriptData, setTranscriptData] = useState(null);
  const [isTranscriptLoading, setIsTranscriptLoading] = useState(false);
  const quillRef = useRef(null);
  const noteSelectionRef = useRef(null);
  const notesContainerRef = useRef(null);
  const noteImageUploadCountRef = useRef(0);
  const shouldSaveNotesAfterImageUploadRef = useRef(false);

  // New Notes State
  const [showToolbar, setShowToolbar] = useState(false);
  const [toolbarPosition, setToolbarPosition] = useState({ top: 0, left: 0 });
  const [showLinkInput, setShowLinkInput] = useState(false);
  const [linkUrl, setLinkUrl] = useState("");
  const [showColorInput, setShowColorInput] = useState(false);
  const [colorValue, setColorValue] = useState("");
  const [isNotesFocused, setIsNotesFocused] = useState(false);
  const [isNotesEmpty, setIsNotesEmpty] = useState(true);
  const [isNoteImageUploading, setIsNoteImageUploading] = useState(false);

  // Helper to determine if the editor is truly empty
  const isEditorEmpty = (content) => {
    if (!content || content === "<p><br></p>") return true;
    const text = content.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
    const hasImage = content.indexOf('<img') !== -1;
    return text === "" && !hasImage;
  };

  // Frontend Metadata 
  const [computedAspectRatio, setComputedAspectRatio] = useState(null);
  const [computedVideoDuration, setComputedVideoDuration] = useState(null);

  // Listen for theme changes (storage events + OS preference changes)
  useEffect(() => {
    const handleStorageChange = () => {
      setAppTheme(resolveTheme(localStorage.getItem("theme")));
    };
    window.addEventListener("storage", handleStorageChange);
    setAppTheme(resolveTheme(localStorage.getItem("theme")));

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleSystemChange = () => {
      const stored = localStorage.getItem("theme");
      if (stored === "system" || !stored) {
        setAppTheme(mediaQuery.matches ? "dark" : "light");
      }
    };
    mediaQuery.addEventListener("change", handleSystemChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      mediaQuery.removeEventListener("change", handleSystemChange);
    };
  }, []);


  useEffect(() => {
    const fetchImage = async () => {
      if (subBucket?.landingPage?.status === true && subBucket?.landingPage?.url) {
        const exists = await checkImageExistence(subBucket?.landingPage?.url);
        setImageSrc(exists ? subBucket?.landingPage?.url : LandingPageNoPreview);
      } else if (subBucket?.landingPage?.status === false && subBucket?.landingPage?.sourceUrl) {
        // setImageSrc(LandingPage);
      } else {
        setImageSrc(LandingPageNoPreview);
      }
    };
    if (subBucket?.landingPage) {
      fetchImage();
    }

  }, [subBucket?.landingPage]);

  // Extract Frontend Metadata
  useEffect(() => {
    const { mediaUrl, isVideo } = getCardMedia(subBucket);
    if (!mediaUrl) return;

    if (isVideo) {
      const video = document.createElement('video');
      video.src = mediaUrl;
      video.onloadedmetadata = () => {
        // Calculate aspect ratio
        if (video.videoWidth && video.videoHeight) {
          const w = video.videoWidth;
          const h = video.videoHeight;
          const ratio = (w / h).toFixed(2);

          if (Math.abs(ratio - 1.78) < 0.1 || Math.abs(ratio - 1.77) < 0.1) setComputedAspectRatio("16:9");
          else if (Math.abs(ratio - 0.56) < 0.1) setComputedAspectRatio("9:16");
          else if (Math.abs(ratio - 1) < 0.1) setComputedAspectRatio("1:1");
          else if (Math.abs(ratio - 1.33) < 0.1) setComputedAspectRatio("4:3");
          else if (Math.abs(ratio - 0.8) < 0.1) setComputedAspectRatio("4:5");
          else if (Math.abs(ratio - 0.75) < 0.1) setComputedAspectRatio("3:4");
          else if (Math.abs(ratio - 1.5) < 0.1) setComputedAspectRatio("3:2");
          else setComputedAspectRatio(`${w} x ${h}`);
        }
        // Calculate duration
        if (video.duration && video.duration !== Infinity) {
          const mins = Math.floor(video.duration / 60);
          const secs = Math.floor(video.duration % 60);
          setComputedVideoDuration(`${mins}:${secs.toString().padStart(2, '0')}`);
        }
      };
    } else {
      const img = new Image();
      img.src = mediaUrl;
      img.onload = () => {
        if (img.width && img.height) {
          const w = img.width;
          const h = img.height;
          const ratio = (w / h).toFixed(2);

          if (Math.abs(ratio - 1.78) < 0.1 || Math.abs(ratio - 1.77) < 0.1) setComputedAspectRatio("16:9");
          else if (Math.abs(ratio - 0.56) < 0.1) setComputedAspectRatio("9:16");
          else if (Math.abs(ratio - 1) < 0.1) setComputedAspectRatio("1:1");
          else if (Math.abs(ratio - 1.33) < 0.1) setComputedAspectRatio("4:3");
          else if (Math.abs(ratio - 0.8) < 0.1) setComputedAspectRatio("4:5");
          else if (Math.abs(ratio - 0.75) < 0.1) setComputedAspectRatio("3:4");
          else if (Math.abs(ratio - 1.5) < 0.1) setComputedAspectRatio("3:2");
          else setComputedAspectRatio(`${w} x ${h}`);
        }
      };
    }
  }, [subBucket]);

  useEffect(() => {
  }, [tags]);
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const cardtype = urlSearchParams.get("card");
    const shared = urlSearchParams.get("shared");
    const Permission = urlSearchParams.get("permission");
    document.querySelectorAll('.ad-lib-second-html .x6ikm8r.x10wlt62.xlyipyv.x5e6ka.xb2kyzz ._4ik4._4ik5').forEach(element => {
      if (!element.textContent.trim()) {
        element.style.display = 'none';
      }
    });
    if (Permission) {
      setUserPermission(Permission);
    }
    if (shared) {
      setSharedToken(true);
    }
    if (cardtype === "bookmark") {
      setBookmarkRestrict(true);
    } else if (cardtype === "file") {
      setFileRestrict(true);
    }
  }, []);

  const handleFocus = (e) => {
    e.stopPropagation();
    setIsTagOpen(true);
  };
  const fetchTags = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API}tags/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }
      );
      setTagOptions(response?.data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);
  const handleCardLink = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}cards/public-url`,
        {
          itemId: cardId.id,
          isPublic: true,
          itemType: "Card",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.data) {
        if (iOS) {
          setOpenCopyLink(true);
          setPublicUrl(response?.data?.data);
          // var data = [new ClipboardItem({ "text/plain": Promise.resolve(new Blob([response?.data?.data], { type: "text/plain" }) )})];
          // navigator.clipboard.write(data).then(function() {
          //   toastify("success", "Public link is copied to clipboard");
          // }, function() {
          //   // console.error("Unable to write to clipboard. :-(");
          //   toastify("error", "Unable to write to clipboard. :-(" );
          // });
        } else {

          const tempInput = document.createElement("input");
          tempInput.value = response?.data?.data;

          // Append the input element to the DOM
          document.body.appendChild(tempInput);

          // Select the input element's text and copy it to clipboard
          tempInput.select();
          document.execCommand("copy");

          // Remove the temporary input element
          document.body.removeChild(tempInput);

          toastify("success", response.data.message);

        }
      }
    } catch (error) {
      console.error(error?.response?.data?.message, "error msg");
      toastify("error", error?.response?.data?.message);
    }
  };




  useEffect(() => {
    // Function to fetch data from the API and update the state
    const token = localStorage.getItem("token");
    const fetchBuckets = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}buckets/user-buckets`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        ); // Replace this with the actual API endpoint
        setBuckets(response?.data?.data?.bucketList); // Assuming the API response is an array of bucket objects
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (token) {
      fetchBuckets();
    }
  }, []);
  useEffect(() => {
  }, [code]);


  const handleMoveto = () => {
    setOpenMove(true);
    setOptionSelect("MoveTo");
  };
  const filteredOptions = tagOptions.filter((option) =>
    option.name.toLowerCase().includes(inputValueSet.toLowerCase())
  );

  const handleSetInputValue = (e) => {
     // You can set it dynamically based on some condition if needed
    // Get the element using document.querySelector
    const element = document.querySelector('.react-tagsinput-input');
    // Apply the width style
    if (element) {
      element.style.width = 'auto!important';
    }
    setTagswidth("tagname-changetagsinput");
    setInputValueSet(e);
    setIsTagOpen(true);
  };

  const handleCopyto = () => {
    setOpenCopy(true);
    setOptionSelect("CopyTo");
  };
  const handleBlur = () => {
    setIsTagOpen(false);
  };

  const closeSharePop = () => {
    setBucketSharePopup(false);
  };
  const handleSharePop = (id) => {
    setShareBucketId(id);
    setBucketSharePopup(true);
  };
  const handleDelete = () => {
    setIsOpens(true);
  };
  const closeMoveModal = () => {
    setOpenMove(false);
    setSearchBucket("");
  };





  const uploadAndInsertNoteImage = async (file) => {
    if (!file?.type?.startsWith("image/")) return;

    noteImageUploadCountRef.current += 1;
    setIsNoteImageUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", "other");

      const response = await services.uploadImage(formData, false);
      const uploadedAsset = response?.data?.asset || response?.asset || response?.data || response;
      const uploadedImageUrl = uploadedAsset?.url || response?.data?.url || response?.url;

      if (!uploadedImageUrl) {
        throw new Error("The image upload response did not include a URL.");
      }

      if (quillRef.current) {
        const quill = quillRef.current.getEditor();
        const range = quill.getSelection() || { index: quill.getLength() };
        quill.insertEmbed(range.index, "image", uploadedImageUrl);
        if (quill.hasFocus()) {
          quill.setSelection(range.index + 1, 0, "silent");
        }
        setIsNotesEmpty(false);
      }
    } catch (error) {
      console.error("Failed to upload note image:", error);
      toast.error("Failed to upload image. Please try again.", { position: "bottom-center" });
    } finally {
      noteImageUploadCountRef.current -= 1;
      if (noteImageUploadCountRef.current === 0) {
        setIsNoteImageUploading(false);
        if (shouldSaveNotesAfterImageUploadRef.current) {
          shouldSaveNotesAfterImageUploadRef.current = false;
          handleSaveNotes();
        }
      }
    }
  };

  const handlePaste = (event) => {
    const clipboardData = event.clipboardData || window.clipboardData;
    if (!clipboardData) return;

    const html = clipboardData.getData("text/html");
    const text = clipboardData.getData("text/plain") ||
      (html ? new DOMParser().parseFromString(html, "text/html").body.textContent : "");

    if (text && quillRef.current) {
      // Quill's default paste focuses a hidden clipboard element, which dismisses
      // the mobile keyboard. Insert plain text at the current selection instead.
      event.preventDefault();
      event.stopPropagation();
      const quill = quillRef.current.getEditor();
      const range = quill.getSelection() || noteSelectionRef.current || { index: quill.getLength() - 1, length: 0 };
      quill.deleteText(range.index, range.length, "user");
      quill.insertText(range.index, text, "user");
      quill.setSelection(range.index + text.length, 0, "silent");
      return;
    }

    const imageItem = Array.from(clipboardData.items || []).find((item) => item.type.startsWith("image/"));
    if (imageItem) {
      event.preventDefault();
      event.stopPropagation();
      uploadAndInsertNoteImage(imageItem.getAsFile());
    }
  };










  const handleSaveNotes = useCallback(async () => {
    if (noteImageUploadCountRef.current > 0) {
      shouldSaveNotesAfterImageUploadRef.current = true;
      return;
    }

    const token = localStorage.getItem("token");
    // Get content from Quill instance if available
    const content = quillRef.current ? quillRef.current.getEditor().root.innerHTML : code;

    if (content === "Loading...") return;

    try {
      await axios.patch(
        `${process.env.REACT_APP_API}cards/update`,
        { cardId: cardId.id, note: content },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Notes saved successfully", { position: "bottom-center" });
      // Update code state with the current content from the editor
      setCode(content);
      // We avoid callings bucketUpdate() here to keep the current editor state 
      // instead of re-fetching and potentially hitting a race condition
      setSubBucket(prev => ({ ...prev, note: content }));
    } catch (error) {
      console.error(error);
      toast.error("Failed to save notes", { position: "bottom-center" });
    }
  }, [cardId.id, code]);

  // New Notes Logic (simplified for ReactQuill)
  useEffect(() => {
    if (activeTab === "notes" && quillRef.current && code !== "Loading...") {
      const editor = quillRef.current.getEditor();
      if (!isNotesFocused && editor.root.innerHTML !== code) {
        editor.root.innerHTML = code || "";
        const isEmpty = !code || code === "<p><br></p>" || (editor.getText().trim() === "" && code.indexOf('<img') === -1);
        setIsNotesEmpty(isEmpty);
      }
    }
  }, [activeTab, code, isNotesFocused]);

  const handleTextSelection = () => {
    const selection = window.getSelection();
    if (selection.rangeCount > 0 && selection.toString().trim().length > 0) {
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();

      // Calculate position above the text
      // We use a fixed offset to ensure it doesn't block the text
      const toolbarHeight = 60;
      const gap = 12;

      setToolbarPosition({
        top: rect.top - toolbarHeight - gap,
        left: rect.left + rect.width / 2 - 150, // center horizontally roughly
      });
      setShowToolbar(true);
    } else {
      setShowToolbar(false);
      setShowLinkInput(false);
      setShowColorInput(false);
    }
  };

  // Click outside listener for saving notes
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notesContainerRef.current && !notesContainerRef.current.contains(event.target)) {
        if (isNotesFocused) {
          setIsNotesFocused(false);
          setShowToolbar(false);
          if (noteImageUploadCountRef.current > 0) {
            shouldSaveNotesAfterImageUploadRef.current = true;
          } else {
            handleSaveNotes();
          }
        }
      }
    };

    if (activeTab === "notes") {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeTab, isNotesFocused, handleSaveNotes]);

  const formatText = (command, value = null) => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      editor.focus();

      const mapping = {
        'bold': 'bold',
        'italic': 'italic',
        'underline': 'underline',
        'strikeThrough': 'strike',
        'insertUnorderedList': 'list',
        'createLink': 'link',
        'foreColor': 'color'
      };

      const format = mapping[command] || command;

      if (command === 'insertUnorderedList') {
        const currentFormat = editor.getFormat();
        editor.format('list', currentFormat.list === 'bullet' ? false : 'bullet');
      } else if (command === 'createLink') {
        // Handled by applyLink usually, but if called directly:
        if (value) editor.format('link', value);
      } else {
        const currentFormat = editor.getFormat();
        editor.format(format, currentFormat[format] ? false : (value || true));
      }
    }
    handleTextSelection();
  };

  const toggleBulletList = () => formatText("insertUnorderedList");
  const createLink = () => setShowLinkInput(true);
  const changeColor = () => setShowColorInput(true);

  const applyLink = () => {
    if (linkUrl) {
      formatText("createLink", linkUrl);
      setLinkUrl("");
      setShowLinkInput(false);
      setShowToolbar(false);
    }
  };

  const applyColor = () => {
    if (colorValue) {
      formatText("foreColor", colorValue);
      setColorValue("");
      setShowColorInput(false);
      setShowToolbar(false);
    }
  };

  const handleDrop = (e) => {
    const files = e.dataTransfer.files;
    if (files && files[0] && files[0].type.startsWith("image/")) {
      e.preventDefault();
      uploadAndInsertNoteImage(files[0]);
    }
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleChildClick = (event) => {
    event.stopPropagation();
  };


  const handleBucketChange = (bucket) => {
    const Selectbucket = bucket._id;
    setSelectedBucket(Selectbucket);
    const newBucket = bucket.name;
    setSearchBucket(newBucket);
    setIsBucketOpen(false);
  };
  const handleDownloadFile = () => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    const { mediaUrl, isVideo } = getCardMedia(subBucket);

    if (mediaUrl) {
      axios
        .post(
          `${process.env.REACT_APP_API}cards/download-file`,
          { fileUrl: mediaUrl },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          const base64Data = response?.data?.data?.fileBase64;
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          // Determine extension and MIME type
          let extension = isVideo ? 'mp4' : 'png';
          try {
            const urlPath = new URL(mediaUrl).pathname;
            const urlExt = urlPath.split('.').pop().toLowerCase();
            if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'mp4', 'mov', 'svg'].includes(urlExt)) {
              extension = urlExt;
            }
          } catch (e) {
            console.error("Error parsing URL extension:", e);
          }

          const mimeType = isVideo ? 'video/mp4' : `image/${extension === 'jpg' ? 'jpeg' : (extension === 'svg' ? 'svg+xml' : extension)}`;
          const blob = new Blob([byteArray], { type: mimeType });
          const url = URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = `${subBucket?.title?.replace(/[^a-z0-9]/gi, '_').toLowerCase() || 'media'}.${extension}`;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();

          URL.revokeObjectURL(url);
          setIsLoading(false);
          toastify("success", "File downloaded successfully");
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
          setIsLoading(false);
          toastify("error", "Error downloading file");
        });
    } else {
      setIsLoading(false);
      toastify("error", "No media found to download");
    }
  };
  const handleSubBucketSelectChange = (subbucket, text) => {
    // if (BookmarkRestrict === true && text === "copy") {
    //   toastify("error", "To copy bookmarks, you must select a main bucket");
    // } else if (BookmarkRestrict === true && text === "move") {
    //   toastify("error", "To move bookmarks, you must select a main bucket");
    // } else if (fileRestrict === true && text === "copy") {
    //   toastify("error", "To copy files, you must select a main bucket");
    // } else if (fileRestrict === true && text === "move") {
    //   toastify("error", "To move files, you must select a main bucket");
    // } else {
    const newBucket = subbucket._id;
    setSelectedBucket(newBucket);
    setSearchBucket(subbucket.name);
    setIsBucketOpen(false);
    // }

    // setHoveredOption(hoveredOption);
    // handleTagsChange([...tags, newTag]);
    // handleBlur()
  };
  const filteredBuckets = buckets?.filter((bucket) => {
    const bucketNameMatches = bucket.name.toLowerCase().includes(searchBucket);
    const subBucketMatches = bucket.subBuckets?.some((subBucket) =>
      subBucket.name.toLowerCase().includes(searchBucket)
    );
    return bucketNameMatches || subBucketMatches;
  });
  const handleBucketInputChange = (event) => {
    const inputText = event.target.value;
    setSearchBucket(inputText.toLowerCase());
  };



  const handleUpdateCardMenu = async (Id) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API}cards/update`,
        {
          optionType: optionSelect,
          destinationBucketID: selectedBucket,
          cardId: Id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      bucketUpdate();
      toastify("success", response.data.message);
      if (optionSelect === "MoveTo") {
        closeMoveModal();
      }
      if (optionSelect === "CopyTo") {
        closeCopyModal();
      }
      setSearchBucket("");
      setSelectedBucket("");
      // cardUpdate();
    } catch (error) {
      console.error(error);
      setSelectedBucket("");
      toastify("error", error.response.data.message);
    }
  };





  const closeCopyModal = () => {
    setOpenCopy(false);
    setSearchBucket("");
  };
  function closeCardModal() {
    setIsOpens(false);
  }








  function closePopup() {
    setPopup(false);
  }


  const goBack = () => {
    // window.history.state.idx is provided by React Router. 
    // If it's 0 (or missing), this is the first page the user landed on in this tab.
    // In that case, navigate(-1) would take them out of the app or do nothing.
    const isFirstPage = !window.history.state || window.history.state.idx === 0;

    if (isFirstPage) {
      if (subBucket?.bucketId?._id) {
        if (subBucket?.bucketId?.parent === false) {
          navigate(`/app/sub-buckets/${subBucket?.bucketId?._id}?bucketId=${mainBucket?._id}&name=${mainBucket?.name}`);
        } else {
          navigate(`/app/buckets/${subBucket?.bucketId?._id}`);
        }
      } else {
        navigate("/app/card");
      }
    } else {
      navigate(-1);
    }
  };
  const handleDeleteCard = async (Id) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API}cards/delete`,
        {
          data: { deletedIds: Id },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // navigate(-1,{replace:true});

      toastify("success", response.data.message);
      closeCardModal();

      if (window.history.length > 1) {
        window.history.go(-1);
      } else {
        if (subBucket?.bucketId?.parent === false) {
          navigate(`/app/sub-buckets/${subBucket?.bucketId?._id}?bucketId=${mainBucket?._id}&name=${mainBucket?.name}`);
        } else {
          navigate(`/app/buckets/${subBucket?.bucketId?._id}`);
        }
      }

    } catch (error) {
      console.error(error);
      closeCardModal();
      toastify("error", error.response.data.message);
    }
  };




  // let org_html = document.getElementsByClassName("x1n2onr6").innerHTML;
  // let new_html = "<div class='slidesInner'>" + org_html + "</div>";
  // document.getElementsByClassName("toggle-view-icon").innerHTML = new_html;

  // const element = document.getElementsByClassName('ql-picker-label');
  // if (element) {
  //     for (let i = 0; i < element.length; i++) {
  //         element[i].addEventListener('click', handleClick);
  //       }
  // //   element.addEventListener('click', handleClick);
  // }
  useEffect(() => {
    // api url
    // Function to make the API call
    const fetchData = async (intervalId = "") => {
      const token = localStorage.getItem("token");
      await axios
        .get(`${process.env.REACT_APP_API}cards/single-card/${cardId.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(function (response) {
          setBucketCreated(false);
          setIsLoading(false);
          // if (
          //   (intervalId && response?.data?.data?.landingPage?.status) ||
          //   !response?.data?.data?.landingPage?.sourceUrl
          // ) {
          //   clearInterval(intervalId);
          // }
          const allTags = response?.data?.data?.tags?.map((tag) => tag.name);
          setTags(allTags);
          setSubBucket(response?.data?.data);
          const noteContent = response?.data?.data?.note ?? "";
          setCode(noteContent);
          setIsNotesEmpty(isEditorEmpty(noteContent));
          setSourceUrl(response?.data?.data.content.sourceUrl);
          if (!response?.data?.data.content.sourceUrl.includes('facebook.com') && response?.data?.data.cardType === 'facebook') {
            setSourceUrl('https://www.facebook.com' + response?.data?.data.content.sourceUrl);
          }


          setImageUrl(response?.data?.data.content.imageUrl?.url);
          setStarCard(response?.data?.data.starred);
          setMainBucket(response?.data?.data?.parentBukcet);
          setIntervalState(current => !current);
          const sharedArray = response?.data?.data?.shared;
          let isPublic = false; // Initialize the isPublic state to false

          if (sharedArray && sharedArray.length > 0) {
            // Iterate through the array and check each object's isPublic property
            for (const sharedItem of sharedArray) {
              if (sharedItem.isPublic === true) {
                isPublic = true; // Set the isPublic state to true if any object has isPublic set to true
                break; // Exit the loop early since we found a match
              }
            }
            setSharedPermission(isPublic);
          }
        })
        .catch(function (error) {
          console.error(error);
          if (error?.response?.data?.statusCode) {
            if ((error?.response?.data?.statusCode === 404 || error?.response?.data?.statusCode === "404")) {
              navigate(`/notFound`)
            }
          }
        });
    };
    fetchData();
  }, [bucketCreated, cardId.id, navigate]);

  useEffect(() => {
    const fetchDataInterval = async (intervalId = "") => {
      const token = localStorage.getItem("token");
      if (intervalId) {
        await axios
          .get(`${process.env.REACT_APP_API}cards/single-card/${cardId.id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then(function (response) {
            setSubBucket(response?.data?.data);
            if (
              (intervalId && response?.data?.data?.landingPage?.status) ||
              !response?.data?.data?.landingPage?.sourceUrl
            ) {
              // setIntervalState(current => !current);
              clearInterval(intervalId);
            }
          })
          .catch(function (error) {
            console.error(error?.response?.data);
            if (error?.response?.data?.statusCode) {
              if ((error?.response?.data?.statusCode === 404 || error?.response?.data?.statusCode === "404")) {
                navigate(`/notFound`)
              }
            }
          });
      }
    };

    const intervalId = setInterval(() => {
      fetchDataInterval(intervalId);
    }, 8000); // 5000 milliseconds interval (adjust as needed)
    // (subBucket?.landingPage?.status && subBucket?.landingPage?.sourceUrl) || (!subBucket?.landingPage?.sourceUrl)
    if (subBucket?.landingPage?.status) {
      clearInterval(intervalId);
    }

    return () => clearInterval(intervalId); // Cleanup function
  }, [intervalState, cardId.id, navigate, subBucket?.landingPage?.status]);

  function bucketUpdate() {
    setBucketCreated(!bucketCreated);
  }

  const handleTitleChange = (updatedCardId, title) => {
    setSubBucket((card) => card?._id === updatedCardId ? { ...card, title } : card);
  };

  // if(matchesApiFlag(subBucket?.landingPage?.status, false)){
  //     const intervalId = setInterval(() => {
  //         bucketUpdate();
  //       }, 5000);
  // }

  const filterDropDown = [
    { name: "Date Swiped", href: "#" },
    { name: "Recent Activity", href: "#" },
    { name: "Ascending Order", href: "#" },
    { name: "Descending Order", href: "#" },
    { name: "Manual", href: "#" },
  ];

  useState(filterDropDown[0].name);


  const pendingCardNavigation = useRef(false);
  useEffect(() => {
    let active = true;
    let resetTimer;
    const handleKeyDown = async (event) => {
      if (pendingCardNavigation.current) return;
      const target = document.activeElement;
      if (target?.isContentEditable || ['INPUT', 'TEXTAREA'].includes(target?.tagName)) return;
      if (document.getElementsByClassName('fullpageClick active').length !== 0) return;
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

      pendingCardNavigation.current = true;
      setFetchingCard(true);
      const token = localStorage.getItem('token');
      const direction = event.key === 'ArrowRight' ? 'next' : 'prev';
      try {
        const response = await axios.get(
          process.env.REACT_APP_API + 'cards/single-card/' + cardId.id + '?' + direction + '=true',
          { headers: { Authorization: 'Bearer ' + token } }
        );
        if (!active) return;
        const nextCardId = response?.data?.data?._id;
        if (nextCardId) {
          navigate('/app/card-detail/' + nextCardId);
          setBucketCreated(true);
        }
      } catch (error) {
        if (active) console.error(error);
      } finally {
        if (active) {
          resetTimer = setTimeout(() => {
            pendingCardNavigation.current = false;
            setFetchingCard(false);
          }, 1000);
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      active = false;
      pendingCardNavigation.current = false;
      clearTimeout(resetTimer);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [cardId.id, navigate]);

  // const handleChangeCardClick = (value) => {
  //   if(value===1){
  //     setSelection("next")
  //   }
  //   else{
  //     setSelection("previous")
  //   }
  //    // Clear any existing interval
  //   FetchCard(); // Fetch data immediately

  //    // Store the new intervalId in the state
  // };


  async function checkImageExistence(url) {
    return new Promise(async (resolve) => {
      try {
        var img = new Image();
        img.onload = function () {
          resolve(true);
        };
        img.onerror = function () {
          resolve(false);
        };
        img.src = url;
      } catch (error) {
        console.error("Error checking image existence:", error);
        resolve(false);
      }
    });
  }
  // checkImageExistence(subBucket?.landingPage?.url, function (exists) {
  //   if (exists) {
  //     // return subBucket?.landingPage?.url;
  //   } else {
  //     // return LandingPageNoPreview;
  //   }
  // })

  let videoIframe = "";
  let videoIframePopup = "";
  if (
    subBucket?.content?.imageUrl.length > 0 &&
    subBucket?.content?.imageUrl[0].urlType === "Video" &&
    subBucket?.content?.html &&
    subBucket?.content?.imageUrl[0].url
  ) {
    videoIframe = subBucket?.content?.html;
    const tempElement = document.createElement("div");
    tempElement.innerHTML = videoIframe;
    // tempElement.find('iframe').attr('')
    const iframes = tempElement.querySelector("iframe");
    if (iframes) {
      const videoElement = document.createElement("video");
      videoElement.controls = isPlaying ? true : false;
      // videoElement.autoplay = true;

      const sourceElement = document.createElement("source");
      sourceElement.src = subBucket?.content?.imageUrl[0].url;
      sourceElement.type = "video/mp4";

      videoElement.appendChild(sourceElement);
      const playIcon = document.createElement("div");
      playIcon.className = "play-icon";
      playIcon.innerHTML = "&#9658;";

      // Wrap the video element with a container div
      const videoContainer = document.createElement("div");
      videoContainer.className = "video-container";
      videoContainer.appendChild(videoElement);
      // videoContainer.appendChild(playIcon);

      // Replace the iframe with the video element
      iframes.parentNode.replaceChild(videoContainer, iframes);
      // const myTimeout = setTimeout(myStopFunction, 1000);

      //     function myStopFunction() {
      //         setIsVideoHeight(document.getElementsByTagName('video')[0].clientHeight);
      //     }
    }

    // Get the updated HTML content from the temporary container
    const updatedHtml = tempElement.innerHTML;
    videoIframe = updatedHtml;

    videoIframePopup = subBucket?.content?.html;
    const tempElementPopup = document.createElement("div");
    tempElementPopup.innerHTML = videoIframePopup;
    // tempElement.find('iframe').attr('')
    const iframesPopup = tempElementPopup.querySelector("iframe");
    if (iframesPopup) {
      const videoElementPopup = document.createElement("video");
      videoElementPopup.controls = isPlayingPopup ? true : false;
      // videoElement.autoplay = true;

      const sourceElementPopup = document.createElement("source");
      sourceElementPopup.src = subBucket?.content?.imageUrl[0].url;
      sourceElementPopup.type = "video/mp4";

      videoElementPopup.appendChild(sourceElementPopup);
      // Wrap the video element with a container div
      const videoContainerPopup = document.createElement("div");
      videoContainerPopup.className = "video-container";
      videoContainerPopup.appendChild(videoElementPopup);
      // videoContainer.appendChild(playIcon);

      // Replace the iframe with the video element
      iframesPopup.parentNode.replaceChild(videoContainerPopup, iframesPopup);
    }

    // Get the updated HTML content from the temporary container
    const updatedHtmlPopup = tempElementPopup.innerHTML;
    videoIframePopup = updatedHtmlPopup;
  }
  const renderPlatformIcon = (platform, size = "w-5 h-5") => {
    if (!platform) return null;
    const p = platform.toLowerCase();

    if (p === 'facebook') return (
      <div className={`${size} rounded-full bg-[#1877F2] flex items-center justify-center shrink-0 overflow-hidden shadow-sm`} title="Facebook">
        <Facebook className="w-3.5 h-3.5 text-white" fill="white" />
      </div>
    );
    if (p === 'instagram') return (
      <div className={`${size} rounded-full bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 flex items-center justify-center shrink-0 overflow-hidden shadow-sm`} title="Instagram">
        <Instagram className="w-3.5 h-3.5 text-white" />
      </div>
    );
    if (p === 'tiktok') return (
      <div className={`${size} rounded-full bg-black flex items-center justify-center shrink-0 overflow-hidden shadow-sm`} title="TikTok">
        <img src={tiktokIcon} alt="TikTok" className="w-3 h-3 object-contain invert" />
      </div>
    );
    if (p === 'youtube') return (
      <div className={`${size} rounded-full bg-red-600 flex items-center justify-center shrink-0 overflow-hidden shadow-sm`} title="YouTube">
        <img src={youtubeIcon} alt="YouTube" className="w-3.5 h-3.5 object-contain" />
      </div>
    );
    if (p === 'twitter' || p === 'x') return (
      <div className={`${size} rounded-full bg-black flex items-center justify-center shrink-0 overflow-hidden shadow-sm`} title="Twitter/X">
        <img src={twitterlogo} alt="Twitter" className="w-3 h-3 object-contain" />
      </div>
    );
    if (p === 'audience network' || p === 'audience') return (
      <div className={`${size} rounded-full flex items-center justify-center shrink-0 overflow-hidden shadow-sm`} title="Audience Network">
        <img src={audienceIcon} alt="Audience Network" className="w-full h-full object-cover" />
      </div>
    );
    if (p === 'messenger' || p === 'facebook messenger' || p === 'facebook_messenger') return (
      <div className={`${size} rounded-full flex items-center justify-center shrink-0 overflow-hidden shadow-sm`} title="Messenger">
        <img src={messengerIcon} alt="Messenger" className="w-full h-full object-cover" />
      </div>
    );
    return (
      <div className={`${size} rounded-full flex items-center justify-center shrink-0 overflow-hidden shadow-sm bg-gray-200 dark:bg-white/10`} title={platform}>
        <Users className="w-3.5 h-3.5 text-gray-500" />
      </div>
    );
  };


  const handleTagsChange = async (newTags) => {
    // TODO: add api call to update tags.
    setTags(newTags);
    setInputValueSet("");
    JSON.parse(localStorage.getItem("userData"));
    const token = localStorage.getItem("token");
    const payload = newTags?.map((tag) => {
      return {
        name: tag,
        // parent: true,
        // subTags: [],
        // userId: userData?._id,
      };
    });
    await axios.patch(
      `${process.env.REACT_APP_API}cards/update`,
      { cardId: cardId.id, tags: payload },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const inputElement = document.querySelector(".react-tagsinput-input");
     // You can set it dynamically based on some condition if needed
    // Get the element using document.querySelector
    // Check if the input element exists before calling focus
    if (inputElement) {
      inputElement.style.width = '100px!important';
      inputElement.focus();
    }
    setTagswidth("tagname-tagsinput")
    bucketUpdate();
  };




  const fetchTranscript = async () => {
    // Check if transcript data is already in state or in subBucket content
    if (transcriptData && transcriptData.length > 0) return;

    if (subBucket?.content?.transcriptText && subBucket.content.transcriptText.length > 0) {
      setTranscriptData(subBucket.content.transcriptText);
      return;
    }

    setIsTranscriptLoading(true);
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}cards/generate-transcript/${cardId.id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTranscriptData(response?.data?.data?.transcript || []);
      setIsTranscriptLoading(false);
    } catch (error) {
      console.error("Error fetching transcript:", error);
      setIsTranscriptLoading(false);
      toastify("error", "Failed to load transcript");
    }
  };

  const handleCopyTranscript = () => {
    if (!transcriptData || transcriptData.length === 0) return;
    const fullText = transcriptData.map(t => `${t.timestamp}: ${t.text}`).join('\n');
    navigator.clipboard.writeText(fullText);
    toastify("success", "Transcript copied to clipboard");
  };

  return (
    <div className="flex min-h-screen bg-gray-50 dark:bg-[#0a0a0a]">
      {isLoading ? (
        <div className="App-loading w-full flex items-center justify-center min-h-screen">
          <div className="App-logo" title="Zimzee" />
        </div>
      ) : (
        <div className="flex-1 flex flex-col w-full">

          {/* Breadcrumb Top Bar */}
          <div className={`px-6 pt-2 pb-4 border-b flex items-center gap-2 text-sm ${appTheme === "dark" ? "bg-[#0a0a0a] border-white/10" : "bg-white border-gray-200"}`}>
            <button
              onClick={goBack}
              className={`rounded-xl flex items-center cursor-pointer  gap-1 font-medium transition-colors px-3 py-2 ${appTheme === "dark" ? "text-gray-400 hover:text-white hover:bg-zinc-800" : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"}`}
            >
              <ChevronLeft className="h-4 w-4" />
              <span>{subBucket?.bucketId?.name || "All Cards"}</span>
            </button>
            {/* {subBucket?.bucketId && (
              <>
                <span className={`${appTheme === "dark" ? "text-gray-600" : "text-gray-400"}`}>/</span>
                <a
                  href={subBucket?.bucketId?.parent === false
                    ? `/app/sub-buckets/${subBucket?.bucketId?._id}?bucketId=${mainBucket?._id}&name=${mainBucket?.name}`
                    : `/app/buckets/${subBucket?.bucketId?._id}`}
                  className={`font-medium transition-colors no-underline ${appTheme === "dark" ? "text-gray-300 hover:text-white" : "text-gray-700 hover:text-gray-900"}`}
                >
                  {subBucket?.bucketId?.name || "Bucket"}
                </a>
              </>
            )} */}
            <span className={`${appTheme === "dark" ? "text-gray-600" : "text-gray-400"}`}>/</span>
            <span className={`${appTheme === "dark" ? "text-gray-500" : "text-gray-500"}`}>
              {subBucket?.title || subBucket?.content?.extractedData?.brandName || "Card"}
            </span>
          </div>

          <main className="card-detail-layout flex flex-1 items-stretch">
            <div className={`card-detail-preview flex-1 flex flex-col items-center px-6 pt-12 pb-12 ${appTheme === "dark" ? "bg-[#0a0a0a]" : "bg-gray-50"}`}>
              {/* Card Preview */}
              <div className={`w-full ${computedAspectRatio === "16:9" ? "max-w-[800px]" : computedAspectRatio === "9:16" ? "max-w-[400px]" : ["4:3", "3:2"].includes(computedAspectRatio) ? "max-w-[800px]" : "max-w-[600px]"}`}>
                <DetailCard
                  handleSharePop={(id) => handleSharePop(id)}
                  starred={subBucket?.starred || false}
                  buckets={buckets}
                  cardUpdate={bucketUpdate}
                  onTitleChange={handleTitleChange}
                  cardId={subBucket?._id || cardId.id}
                  cardType={subBucket?.cardType}
                  sharedBy={[]}
                  sharedUsers={[]}
                  sharedLength={subBucket?.shared?.length || 0}
                  title={subBucket?.title}
                  content={subBucket?.content}
                  note={subBucket?.note}
                  tags={subBucket?.tags || []}
                  postDetail={subBucket?.postDetail || ""}
                  updated={subBucket?.updatedAt}
                  adData={subBucket?.adData}
                  aiData={subBucket?.content?.extractedData || null}
                  showCopy={true}
                  computedAspectRatio={computedAspectRatio}
                />
              </div>
              {/* Quick Actions Toolbar — 20px below card */}
              <div className="mt-5 flex-shrink-0 w-full max-w-[600px]">
                <div className={`flex items-center justify-center gap-2 py-2 px-4 rounded-xl border ${appTheme === "dark" ? "bg-[#111111] border-white/5" : "bg-white border-gray-200"}`}>
                  <button onClick={handleDownloadFile} className="group relative inline-flex items-center justify-center rounded-xl h-9 w-9 text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors dark:text-gray-400 dark:hover:bg-zinc-800 dark:hover:text-white">
                    <Download className="h-4 w-4" />
                    <span className={`absolute top-full mt-2 hidden group-hover:block text-[11px] px-2 py-1 rounded whitespace-nowrap z-50 shadow-sm ${appTheme === "dark" ? "bg-zinc-900 text-white border border-zinc-800" : "bg-gray-100 text-gray-700 border border-gray-200"}`}>Download</span>
                  </button>
                  <a href={subBucket?.content?.sourceUrl || sourceUrl} target="_blank" className="group relative inline-flex items-center justify-center rounded-xl h-9 w-9 text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors dark:text-gray-400 dark:hover:bg-zinc-800 dark:hover:text-white" rel="noopener noreferrer">
                    <ExternalLink className="h-4 w-4" />
                    <span className={`absolute top-full mt-2 hidden group-hover:block text-[11px] px-2 py-1 rounded whitespace-nowrap z-50 shadow-sm ${appTheme === "dark" ? "bg-zinc-900 text-white border border-zinc-800" : "bg-gray-100 text-gray-700 border border-gray-200"}`}>View Original</span>
                  </a>
                  <button onClick={handleCardLink} className="group relative inline-flex items-center justify-center rounded-xl h-9 w-9 text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors dark:text-gray-400 dark:hover:bg-zinc-800 dark:hover:text-white">
                    <LinkIcon className="h-4 w-4" />
                    <span className={`absolute top-full mt-2 hidden group-hover:block text-[11px] px-2 py-1 rounded whitespace-nowrap z-50 shadow-sm ${appTheme === "dark" ? "bg-zinc-900 text-white border border-zinc-800" : "bg-gray-100 text-gray-700 border border-gray-200"}`}>Copy Link</span>
                  </button>
                  <button onClick={handleCopyto} className="group relative inline-flex items-center justify-center rounded-xl h-9 w-9 text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors dark:text-gray-400 dark:hover:bg-zinc-800 dark:hover:text-white">
                    <File className="h-4 w-4" />
                    <span className={`absolute top-full mt-2 hidden group-hover:block text-[11px] px-2 py-1 rounded whitespace-nowrap z-50 shadow-sm ${appTheme === "dark" ? "bg-zinc-900 text-white border border-zinc-800" : "bg-gray-100 text-gray-700 border border-gray-200"}`}>Copy To</span>
                  </button>
                  <button onClick={handleMoveto} className="group relative inline-flex items-center justify-center rounded-xl h-9 w-9 text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors dark:text-gray-400 dark:hover:bg-zinc-800 dark:hover:text-white">
                    <FolderInput className="h-4 w-4" />
                    <span className={`absolute top-full mt-2 hidden group-hover:block text-[11px] px-2 py-1 rounded whitespace-nowrap z-50 shadow-sm ${appTheme === "dark" ? "bg-zinc-900 text-white border border-zinc-800" : "bg-gray-100 text-gray-700 border border-gray-200"}`}>Move To</span>
                  </button>
                  <button onClick={() => handleSharePop(cardId.id)} className="group relative inline-flex items-center justify-center rounded-xl h-9 w-9 text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors dark:text-gray-400 dark:hover:bg-zinc-800 dark:hover:text-white">
                    <Share2 className="h-4 w-4" />
                    <span className={`absolute top-full mt-2 hidden group-hover:block text-[11px] px-2 py-1 rounded whitespace-nowrap z-50 shadow-sm ${appTheme === "dark" ? "bg-zinc-900 text-white border border-zinc-800" : "bg-gray-100 text-gray-700 border border-gray-200"}`}>Share</span>
                  </button>
                  <button onClick={handleDelete} className="group relative inline-flex items-center justify-center rounded-xl h-9 w-9 text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors dark:text-gray-400 dark:hover:bg-zinc-800 dark:hover:text-white">
                    <Trash2 className="h-4 w-4" />
                    <span className={`absolute top-full mt-2 hidden group-hover:block text-[11px] px-2 py-1 rounded whitespace-nowrap z-50 shadow-sm ${appTheme === "dark" ? "bg-zinc-900 text-white border border-zinc-800" : "bg-gray-100 text-gray-700 border border-gray-200"}`}>Delete</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Right Panel */}
            <div className="card-detail-sidebar w-[380px] border-l flex flex-col bg-white border-gray-200 dark:bg-[#111111] dark:border-white/5">

              {/* Tabs */}
              <div className="border-b border-gray-200 dark:border-white/5">
                <div className="flex items-center justify-between px-4 pt-4 pb-0">
                  <div className="flex items-center">
                    <button onClick={() => setActiveTab("details")} className={`px-3 py-2.5 text-sm font-medium border-b-2 transition-colors ${activeTab === "details" ? "border-gray-900 text-gray-900 dark:border-white dark:text-white" : "border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"}`}>
                      Details
                    </button>
                    {(() => {
                      const isVideo = subBucket?.cardType?.toLowerCase() === 'video' || subBucket?.content?.imageUrl?.[0]?.urlType === 'Video' || subBucket?.adData?.['Format']?.toLowerCase() === 'video';
                      if (!isVideo) return null;
                      return (
                        <button onClick={() => { setActiveTab("transcript"); fetchTranscript(); }} className={`px-3 py-2.5 text-sm font-medium border-b-2 transition-colors ${activeTab === "transcript" ? "border-gray-900 text-gray-900 dark:border-white dark:text-white" : "border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"}`}>
                          Transcript
                        </button>
                      );
                    })()}
                    <button onClick={() => setActiveTab("notes")} className={`px-3 py-2.5 text-sm font-medium border-b-2 transition-colors ${activeTab === "notes" ? "border-gray-900 text-gray-900 dark:border-white dark:text-white" : "border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"}`}>
                      Notes
                    </button>
                  </div>
                </div>
              </div>

              {/* Tab Content */}
              <div className="flex-1 overflow-y-auto p-5 pb-12">


                {/* Details Tab */}
                {activeTab === "details" && (
                  <div className="space-y-0">
                    {/* Source */}
                    <div className="flex items-center justify-between py-1.5">
                      <span className="text-sm font-medium text-gray-600 dark:text-gray-400">Source</span>
                      <div className="flex items-center gap-2">
                        {renderPlatformIcon(subBucket?.cardType, "w-5 h-5")}
                        <span className="text-sm text-gray-900 dark:text-white capitalize">{subBucket?.cardType || 'Unknown'}</span>
                        {subBucket?.content?.sourceUrl && (
                          <a
                            href={subBucket.content.sourceUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 transition-colors flex items-center"
                            title="Open Source URL"
                          >
                            <ExternalLink className="h-3.5 w-3.5 ml-0.5" />
                          </a>
                        )}
                      </div>
                    </div>
                    <div className="flex items-center justify-between py-1.5">
                      <span className="text-sm font-medium text-gray-600 dark:text-gray-400">Created</span>
                      <span className="text-sm text-gray-900 dark:text-white">{moment(subBucket?.createdAt).format("MMM D, YYYY @ hh:mm A")}</span>
                    </div>
                    <div className="flex items-center justify-between py-1.5">
                      <span className="text-sm font-medium text-gray-600 dark:text-gray-400">Last Updated</span>
                      <span className="text-sm text-gray-900 dark:text-white">{moment(subBucket?.updatedAt).format("MMM D, YYYY @ hh:mm A")}</span>
                    </div>

                    <div className="my-2 border-t border-gray-200 dark:border-white/5" />

                    {/* Bucket */}
                    <div className="flex items-center justify-between py-1.5">
                      <span className="text-sm text-gray-600 dark:text-gray-400">Bucket</span>
                      <span className="inline-flex items-center rounded-md px-2.5 py-1 text-xs font-normal transition-colors bg-gray-100 text-gray-900 dark:bg-white/10 dark:text-white">
                        <FolderOpen className="h-3 w-3 mr-1" />
                        {subBucket?.bucketId?.name || "Uncategorized"}
                      </span>
                    </div>

                    <div className="my-2 border-t border-gray-200 dark:border-white/5" />

                    {/* Tags */}
                    <div className="py-2">
                      <label className="text-sm font-medium mb-2 block text-gray-600 dark:text-gray-400">Tags</label>
                      <div className="flex flex-wrap gap-2 mb-2">
                        {tags.map((tag) => (
                          <span key={tag} className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-normal tracking-wide transition-colors bg-gray-100 text-gray-900 border border-gray-200 dark:bg-white/10 dark:text-white dark:border-white/10">
                            {tag}
                            <button onClick={() => {
                              const newTags = tags.filter(t => t !== tag);
                              handleTagsChange(newTags);
                            }} className="hover:bg-white/20 hover:text-red-500 rounded-full p-0.5">
                              <X className="h-2.5 w-2.5" />
                            </button>
                          </span>
                        ))}
                      </div>
                      <div className="relative">
                        <input
                          value={inputValueSet}
                          onChange={(e) => handleSetInputValue(e.target.value)}
                          onFocus={handleFocus}
                          onBlur={() => setTimeout(handleBlur, 200)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === ",") {
                              e.preventDefault();
                              const newTag = inputValueSet.trim();
                              if (newTag && !tags.includes(newTag)) {
                                handleTagsChange([...tags, newTag]);
                              }
                            }
                          }}
                          placeholder="Add a tag..."
                          className="flex h-9 w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-white/10 dark:bg-white/5 dark:text-white dark:placeholder:text-gray-500"
                        />
                        {isTagOpen && filteredOptions.length > 0 && (
                          <div className="absolute z-[100] w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg dark:bg-[#111111] dark:border-white/10 max-h-60 overflow-y-auto custom-scrollbar">
                            {filteredOptions.map((option, index) => (
                              <div
                                key={index}
                                onMouseDown={(e) => {
                                  e.preventDefault();
                                  if (!tags.includes(option.name.trim())) {
                                    handleTagsChange([...tags, option.name.trim()]);
                                  } else {
                                    setInputValueSet("");
                                    setIsTagOpen(false);
                                  }
                                }}
                                className="px-3 py-2 text-sm cursor-pointer text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/10"
                              >
                                {option.name}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="my-2 border-t border-gray-200 dark:border-white/5" />

                    {/* Brand */}
                    {subBucket?.adData?.['Brand Name'] && (
                      <div className="flex items-center justify-between py-1.5">
                        <span className="text-sm text-gray-600 dark:text-gray-400">Brand</span>
                        <div className="flex items-center gap-2">
                          <div className="w-5 h-5 rounded bg-gray-200 dark:bg-white/10 flex items-center justify-center text-xs text-gray-700 dark:text-white font-semibold">
                            {subBucket.adData['Brand Name'].charAt(0).toUpperCase()}
                          </div>
                          <span className="text-sm font-medium text-gray-900 dark:text-white">{subBucket.adData['Brand Name']}</span>
                        </div>
                      </div>
                    )}

                    {/* Status */}
                    {subBucket?.adData?.['Status'] && (
                      <div className="flex items-center justify-between py-1.5">
                        <span className="text-sm text-gray-600 dark:text-gray-400">Status</span>
                        <div className="flex items-center gap-2">
                          <div className={`w-2 h-2 rounded-full ${subBucket.adData['Status'] === 'Active' ? 'bg-green-500' : 'bg-gray-400'}`} />
                          <span className="text-sm text-gray-900 dark:text-white">Still Running</span>
                          {subBucket.adData['Ad started date'] && (
                            <span className="text-xs text-gray-500">from {subBucket.adData['Ad started date']}</span>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Time Running */}
                    {subBucket?.adData?.['Ad started date'] && (
                      <div className="flex items-center justify-between py-1.5">
                        <span className="text-sm text-gray-600 dark:text-gray-400">Time Running</span>
                        <div className="flex items-center gap-2">
                          <Clock className="h-4 w-4 text-gray-400" />
                          <span className="text-sm text-gray-900 dark:text-white">
                            {(() => {
                              const started = moment(subBucket.adData['Ad started date'], ['D MMM YYYY', 'MMM D YYYY', 'YYYY-MM-DD']);
                              const now = moment();
                              const days = now.diff(started, 'days');
                              if (days < 1) return '< 1 Day';
                              return `${days} Day${days !== 1 ? 's' : ''}`;
                            })()}
                          </span>
                        </div>
                      </div>
                    )}

                    {/* Format */}
                    {(() => {
                      const isVideo = subBucket?.cardType?.toLowerCase() === 'video' || subBucket?.content?.imageUrl?.[0]?.urlType === 'Video' || subBucket?.adData?.['Format']?.toLowerCase() === 'video';
                      const formatText = isVideo ? "Video" : "Image";
                      return (
                        <div className="flex items-center justify-between py-1.5">
                          <span className="text-sm text-gray-600 dark:text-gray-400">Format</span>
                          <div className="flex items-center gap-2">
                            {isVideo ? <Video className="h-4 w-4 text-gray-400" /> : <Grid3x3 className="h-4 w-4 text-gray-400" />}
                            <span className="text-sm text-gray-900 dark:text-white">{formatText}</span>
                          </div>
                        </div>
                      );
                    })()}

                    {/* Video Duration */}
                    {(() => {
                      const isVideo = subBucket?.cardType?.toLowerCase() === 'video' || subBucket?.content?.imageUrl?.[0]?.urlType === 'Video' || subBucket?.adData?.['Format']?.toLowerCase() === 'video';
                      if (!isVideo) return null;
                      const formattedDur = computedVideoDuration || subBucket?.adData?.['Video Duration'] || subBucket?.content?.extractedData?.videoDuration || subBucket?.content?.imageUrl?.[0]?.metaData?.duration;
                      if (!formattedDur || formattedDur === 'N/A') return null;
                      return (
                        <div className="flex items-center justify-between py-1.5">
                          <span className="text-sm text-gray-600 dark:text-gray-400">Video Duration</span>
                          <div className="flex items-center gap-2">
                            <Clock className="h-4 w-4 text-gray-400" />
                            <span className="text-sm text-gray-900 dark:text-white">{formattedDur}</span>
                          </div>
                        </div>
                      );
                    })()}

                    {/* Niche */}
                    {subBucket?.adData?.['Niche'] && (
                      <div className="flex items-center justify-between py-1.5">
                        <span className="text-sm text-gray-600 dark:text-gray-400">Niche</span>
                        <div className="flex items-center gap-2">
                          <Tag className="h-4 w-4 text-gray-400" />
                          <span className="text-sm text-gray-900 dark:text-white">{subBucket.adData['Niche']}</span>
                        </div>
                      </div>
                    )}

                    {/* Platforms from adData */}
                    {subBucket?.adData?.['Platforms'] && subBucket.adData['Platforms'].length > 0 && (
                      <div className="flex items-start justify-between py-1.5">
                        <span className="text-sm text-gray-600 dark:text-gray-400">Platforms</span>
                        <div className="flex items-center gap-1.5 flex-wrap justify-end max-w-[200px]">
                          {subBucket.adData['Platforms'].map((platform, idx) => (
                            <Fragment key={idx}>
                              {renderPlatformIcon(platform, "w-5 h-5")}
                            </Fragment>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Aspect Ratio */}
                    {(() => {
                      const ratio = computedAspectRatio || subBucket?.adData?.['Aspect Ratio'] || subBucket?.content?.extractedData?.aspectRatio || subBucket?.content?.imageUrl?.[0]?.metaData?.aspectRatio;
                      if (!ratio || ratio === 'N/A') return null;
                      return (
                        <div className="flex items-center justify-between py-1.5">
                          <span className="text-sm text-gray-600 dark:text-gray-400">Aspect Ratio</span>
                          <div className="flex items-center gap-2">
                            <Grid3x3 className="h-4 w-4 text-gray-400" />
                            <span className="text-sm text-gray-900 dark:text-white">{ratio}</span>
                          </div>
                        </div>
                      );
                    })()}

                    {/* Target Market */}
                    {subBucket?.adData?.['Target Market'] && (
                      <div className="flex items-start justify-between py-1.5 gap-4">
                        <span className="text-sm text-gray-600 shrink-0 dark:text-gray-400 pt-0.5">Target Market</span>
                        <div className="flex-1 min-w-0 text-right">
                          <span className="text-sm text-gray-900 break-words dark:text-white">
                            <Users className="inline h-4 w-4 text-gray-400 mr-2 -mt-0.5" />
                            {subBucket.adData['Target Market']}
                          </span>
                        </div>
                      </div>
                    )}


                    {/* Landing Page */}
                    {subBucket?.landingPage?.status === false && subBucket?.landingPage?.sourceUrl ? (
                      <>
                        <div className="my-3 border-t border-gray-200 dark:border-white/5" />
                        <div className="py-2">
                          <label className="text-sm font-medium mb-3 block text-gray-600 dark:text-gray-400">Landing Page</label>
                          <div className="space-y-3 w-[274px] mx-auto">
                            <div className="flex flex-col items-center justify-center p-8 border-2 border-dashed h-[170px] border-orange-500/30 rounded-lg dark:border-orange-500/20 bg-orange-50 dark:bg-orange-500/10">
                              <Loader2 className="w-8 h-8 animate-spin text-orange-500 mb-2" />
                              <p className="text-sm text-orange-600 dark:text-orange-400 text-center font-medium">Processing...</p>
                            </div>
                            <div className="text-xs text-gray-600 dark:text-gray-400 truncate text-center">
                              {(() => { try { return new URL(subBucket.landingPage.sourceUrl).hostname; } catch { return subBucket.landingPage.sourceUrl; } })()}
                            </div>
                            <a
                              href={subBucket.landingPage.sourceUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex items-center justify-center gap-2 w-full px-3 py-2 rounded-xl text-sm font-medium border transition-colors border-gray-200 hover:bg-gray-50 text-blue-600 dark:border-white/10 dark:hover:bg-white/5 dark:text-blue-400"
                            >
                              <ExternalLink className="h-4 w-4" />
                              <span>Visit Landing Page</span>
                            </a>
                          </div>
                        </div>
                      </>
                    ) : subBucket?.landingPage?.status && subBucket?.landingPage?.url && (
                      <>
                        <div className="my-3 border-t border-gray-200 dark:border-white/5" />
                        <div className="py-2">
                          <label className="text-sm font-medium mb-3 block text-gray-600 dark:text-gray-400">Landing Page</label>
                          <div className="space-y-3 w-[274px] mx-auto">
                            <a
                              href={subBucket.landingPage.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="block"
                            >
                              <div
                                className="rounded-lg overflow-y-scroll shadow-lg border-2 h-[170px] border-gray-200 hover:border-blue-400 transition-colors dark:border-white/10 dark:hover:border-blue-500 cursor-pointer"
                                onWheel={(e) => {
                                  const element = e.currentTarget;
                                  const isScrollable = element.scrollHeight > element.clientHeight;
                                  if (isScrollable) {
                                    const atTop = element.scrollTop === 0;
                                    const atBottom = element.scrollTop + element.clientHeight >= element.scrollHeight - 1;
                                    if ((e.deltaY < 0 && !atTop) || (e.deltaY > 0 && !atBottom)) {
                                      e.stopPropagation();
                                    }
                                  }
                                }}
                              >
                                <img
                                  src={subBucket.landingPage.url}
                                  alt="Landing page preview"
                                  className="w-full h-auto"
                                  style={{ minHeight: '200px', objectFit: 'cover' }}
                                  onError={(e) => { e.target.style.display = 'none'; }}
                                />
                              </div>
                            </a>
                            {subBucket.landingPage.sourceUrl && (
                              <div className="text-xs text-gray-600 dark:text-gray-400 truncate text-center">
                                {(() => { try { return new URL(subBucket.landingPage.sourceUrl).hostname; } catch { return subBucket.landingPage.sourceUrl; } })()}
                              </div>
                            )}
                            <a
                              href={subBucket.landingPage.sourceUrl || subBucket.landingPage.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex items-center justify-center gap-2 w-full px-3 py-2 rounded-xl text-sm font-medium border transition-colors border-gray-200 hover:bg-gray-50 text-blue-600 dark:border-white/10 dark:hover:bg-white/5 dark:text-blue-400"
                            >
                              <ExternalLink className="h-4 w-4" />
                              <span>Visit Landing Page</span>
                            </a>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}

                {/* Transcript Tab */}
                {activeTab === "transcript" && (
                  <div className="space-y-4">
                    {/* Video Length Section */}
                    <div
                      className={`p-4 rounded-xl border ${appTheme === "dark" ? "bg-white/5 border-white/10" : "bg-gray-50 border-gray-200"
                        }`}
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <Video className="h-4 w-4 text-gray-400" />
                          <span
                            className={`text-sm font-semibold ${appTheme === "dark" ? "text-white" : "text-gray-900"}`}
                          >
                            Video Length: {computedVideoDuration || "N/A"}
                          </span>
                        </div>
                        <button
                          onClick={handleCopyTranscript}
                          className={`p-1.5 rounded-md transition-colors ${appTheme === "dark" ? "text-gray-400 hover:bg-white/10 hover:text-white" : "text-gray-500 hover:bg-gray-200 hover:text-gray-900"}`}
                          title="Copy Transcript"
                        >
                          <Copy className="h-4 w-4" />
                        </button>
                      </div>
                    </div>

                    {/* Transcript Entries */}
                    <div className="space-y-3">
                      {isTranscriptLoading ? (
                        <div className="flex flex-col items-center justify-center py-10 gap-3">
                          <div className="App-loading" style={{ minHeight: 'auto' }}>
                            <div className="App-logo" title="Zimzee" style={{ width: '40px', height: '40px' }} />
                          </div>
                          <span className={`text-sm ${appTheme === "dark" ? "text-gray-400" : "text-gray-500"}`}>Generating transcript...</span>
                        </div>
                      ) : transcriptData && transcriptData.length > 0 ? (
                        transcriptData.map((entry, index) => (
                          <div
                            key={index}
                            className={`flex gap-3 p-2 rounded-lg hover:bg-white/5 transition-colors ${appTheme === "dark" ? "" : "hover:bg-gray-50"
                              }`}
                          >
                            <span
                              className={`text-xs font-mono flex-shrink-0 ${appTheme === "dark" ? "text-gray-500" : "text-gray-500"
                                }`}
                            >
                              {entry.timestamp}
                            </span>
                            <span className={`text-sm ${appTheme === "dark" ? "text-gray-300" : "text-gray-700"}`}>
                              {entry.text}
                            </span>
                          </div>
                        ))
                      ) : (
                        <div className={`text-center py-10 text-sm ${appTheme === "dark" ? "text-gray-500" : "text-gray-400"}`}>
                          No transcript available for this card.
                        </div>
                      )}
                    </div>

                    {/* Copy Transcript Button */}
                    {transcriptData && transcriptData.length > 0 && (
                      <button
                        onClick={handleCopyTranscript}
                        className={`w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl border transition-colors ${appTheme === "dark" ? "border-white/10 hover:bg-white/5 text-white" : "border-gray-200 hover:bg-gray-50 text-gray-900"
                          }`}
                      >
                        <Copy className="h-4 w-4" />
                        Copy Transcript
                      </button>
                    )}
                  </div>
                )}

                {/* Notes Tab */}
                {activeTab === "notes" && (
                  <div className="card-detail-notes space-y-4 relative" ref={notesContainerRef}>
                    <div className="relative">
                      {isNotesEmpty && !isNotesFocused && (
                        <div
                          className={`absolute inset-0 p-4 pointer-events-none select-none z-10 ${appTheme === "dark" ? "text-gray-500" : "text-gray-400"
                            }`}
                        >
                          <div className="text-sm leading-relaxed">
                            <div>Click here to start typing…</div>
                            <div>Highlight text to format — click outside to save.</div>
                            <div>You can also drag or paste images right into this space.</div>
                          </div>
                        </div>
                      )}
                      {isNoteImageUploading && (
                        <div className={`absolute right-4 top-4 z-20 flex items-center gap-2 rounded-lg px-3 py-2 text-sm shadow-sm ${appTheme === "dark"
                          ? "bg-gray-800 text-gray-200"
                          : "bg-white text-gray-700"
                          }`}>
                          <Loader2 className="h-4 w-4 animate-spin" />
                          Uploading image…
                        </div>
                      )}
                      <div
                        onMouseUp={handleTextSelection}
                        onPasteCapture={handlePaste}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                      >
                        <ReactQuill
                          ref={quillRef}
                          theme="snow"
                          value={code || ""}
                          onChange={(content, delta, source, editor) => {
                            setCode(content);
                            const isEmpty = !content || content === "<p><br></p>" || (editor.getText().trim() === "" && content.indexOf('<img') === -1);
                            setIsNotesEmpty(isEmpty);
                          }}
                          onChangeSelection={(range) => {
                            if (range) noteSelectionRef.current = range;
                          }}
                          modules={{
                            toolbar: false,
                            clipboard: {
                              matchVisual: false,
                            }
                          }}
                          onFocus={() => setIsNotesFocused(true)}
                          className={`min-h-[600px] rounded-xl border transition-all outline-none zimzee-notes-quill ${appTheme === "dark"
                            ? "bg-white/5 border-white/10 text-gray-200 focus-within:border-white/20"
                            : "bg-gray-50 border-gray-200 text-gray-900 focus-within:border-blue-500"
                            }`}
                          style={{
                            minHeight: "600px",
                          }}
                        />
                      </div>
                    </div>

                    {showToolbar && (
                      <div
                        className={`fixed z-[9999] rounded-lg shadow-xl border pointer-events-auto ${appTheme === "dark" ? "bg-[#1A1A1A] border-white/10" : "bg-white border-gray-200"
                          }`}
                        style={{
                          top: `${toolbarPosition.top}px`,
                          left: `${toolbarPosition.left}px`,
                          position: "fixed",
                          willChange: "transform",
                        }}
                      >
                        {!showLinkInput && !showColorInput && (
                          <div className="flex items-center gap-1 p-2">
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => formatText("bold")}
                              className={`h-8 w-8 p-0 rounded ${appTheme === "dark"
                                ? "hover:bg-white/10 text-white"
                                : "hover:bg-gray-100 text-gray-900"
                                }`}
                              title="Bold"
                            >
                              <span className="font-bold">B</span>
                            </Button>
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => formatText("italic")}
                              className={`h-8 w-8 p-0 rounded ${appTheme === "dark"
                                ? "hover:bg-white/10 text-white"
                                : "hover:bg-gray-100 text-gray-900"
                                }`}
                              title="Italic"
                            >
                              <span className="italic">I</span>
                            </Button>
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => formatText("underline")}
                              className={`h-8 w-8 p-0 rounded ${appTheme === "dark"
                                ? "hover:bg-white/10 text-white"
                                : "hover:bg-gray-100 text-gray-900"
                                }`}
                              title="Underline"
                            >
                              <span className="underline">U</span>
                            </Button>
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => formatText("strikeThrough")}
                              className={`h-8 w-8 p-0 rounded ${appTheme === "dark"
                                ? "hover:bg-white/10 text-white"
                                : "hover:bg-gray-100 text-gray-900"
                                }`}
                              title="Strikethrough"
                            >
                              <span className="line-through">S</span>
                            </Button>
                            <div className={`w-px h-6 mx-1 ${appTheme === "dark" ? "bg-white/10" : "bg-gray-200"}`} />
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={toggleBulletList}
                              className={`h-8 w-8 p-0 rounded ${appTheme === "dark"
                                ? "hover:bg-white/10 text-white"
                                : "hover:bg-gray-100 text-gray-900"
                                }`}
                              title="Bullet List"
                            >
                              <List className="h-4 w-4" />
                            </Button>
                            <div className={`w-px h-6 mx-1 ${appTheme === "dark" ? "bg-white/10" : "bg-gray-200"}`} />
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={createLink}
                              className={`h-8 w-8 p-0 rounded ${appTheme === "dark"
                                ? "hover:bg-white/10 text-white"
                                : "hover:bg-gray-100 text-gray-900"
                                }`}
                              title="Add Link"
                            >
                              <LinkIcon className="h-4 w-4" />
                            </Button>
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={changeColor}
                              className={`h-8 w-8 p-0 rounded ${appTheme === "dark"
                                ? "hover:bg-white/10 text-white"
                                : "hover:bg-gray-100 text-gray-900"
                                }`}
                              title="Text Color"
                            >
                              <div className="w-4 h-4 rounded-full border-2 border-current bg-gradient-to-br from-red-500 via-yellow-500 to-blue-500" />
                            </Button>
                          </div>
                        )}

                        {showLinkInput && (
                          <div className="flex items-center gap-2 p-2">
                            <Input
                              type="url"
                              placeholder="Enter URL..."
                              value={linkUrl}
                              onChange={(e) => setLinkUrl(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault()
                                  applyLink()
                                } else if (e.key === "Escape") {
                                  setShowLinkInput(false)
                                  setLinkUrl("")
                                }
                              }}
                              className={`h-8 text-sm w-48 ${appTheme === "dark"
                                ? "bg-white/5 border-white/10 text-white"
                                : "bg-gray-50 border-gray-200"
                                }`}
                              autoFocus
                            />
                            <Button
                              size="sm"
                              onClick={applyLink}
                              className="h-8 px-3 bg-blue-600 hover:bg-blue-700 text-white"
                            >
                              Apply
                            </Button>
                            <Button
                              size="sm"
                              variant="ghost"
                              onClick={() => {
                                setShowLinkInput(false)
                                setLinkUrl("")
                              }}
                              className={`h-8 w-8 p-0 ${appTheme === "dark" ? "hover:bg-white/10" : "hover:bg-gray-100"
                                }`}
                            >
                              <X className="h-4 w-4" />
                            </Button>
                          </div>
                        )}

                        {showColorInput && (
                          <div className="flex items-center gap-2 p-2">
                            <Input
                              type="text"
                              placeholder="e.g., #ff0000, red"
                              value={colorValue}
                              onChange={(e) => setColorValue(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault()
                                  applyColor()
                                } else if (e.key === "Escape") {
                                  setShowColorInput(false)
                                  setColorValue("")
                                }
                              }}
                              className={`h-8 text-sm w-48 ${appTheme === "dark"
                                ? "bg-white/5 border-white/10 text-white"
                                : "bg-gray-50 border-gray-200"
                                }`}
                              autoFocus
                            />
                            <Button
                              size="sm"
                              onClick={applyColor}
                              className="h-8 px-3 bg-blue-600 hover:bg-blue-700 text-white"
                            >
                              Apply
                            </Button>
                            <Button
                              size="sm"
                              variant="ghost"
                              onClick={() => {
                                setShowColorInput(false)
                                setColorValue("")
                              }}
                              className={`h-8 w-8 p-0 ${appTheme === "dark" ? "hover:bg-white/10" : "hover:bg-gray-100"
                                }`}
                            >
                              <X className="h-4 w-4" />
                            </Button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </main>
        </div>
      )}

      {/* Existing modals (ShareCard, Popup, Move, Copy, etc) */}
      {
        BucketSharePopup && (
          <div className="filesuploadpopup relative !z-[999]" style={{ height: "100%" }} onClick={closeSharePop}>
            <div className="subinviteupload-section" onClick={(e) => e.stopPropagation()}>
              <div className="teaminvitesection flex">
                <div className="teammembers-content">Share</div>
                <div className="dismissSubfiles-content cursor-pointer" onClick={closeSharePop}>
                  <img src={BlackDismiss} alt="dismissButton" />
                </div>
              </div>
              <ShareCard shareBucketId={shareBucketId} closeSharePop={closeSharePop} cardsRefresh={bucketUpdate} />
            </div>
          </div>
        )
      }

      {
        popup && (
          <div className="relative !z-[999] flex justify-center items-center" style={{ height: "100%", width: "100%", position: "fixed", top: 0, left: 0, background: "rgba(0,0,0,0.8)" }} onClick={closePopup}>
            <div className="relative bg-white dark:bg-[#1f1f1f] rounded-xl p-6 max-w-[90vw] max-h-[90vh] flex flex-col shadow-2xl" onClick={handleChildClick}>
              <button onClick={closePopup} className="absolute top-4 right-4 bg-red-600 hover:bg-red-700 text-white rounded-full w-10 h-10 flex justify-center items-center shadow-lg transition-all z-[100]">
                <X className="w-5 h-5" />
              </button>
              <div className="popup-img overflow-y-auto overflow-x-hidden custom-scrollbar pr-2">
                {parse(subBucket?.content?.html || "")}
                {subBucket?.content?.imageUrl?.map((img, i) => (
                  <img key={i} src={img.url} className="w-full max-w-4xl mx-auto my-4 rounded-lg object-contain" style={{ maxHeight: '70vh' }} alt="Popup view" />
                ))}
              </div>
            </div>
          </div>
        )
      }

      {/* Action Modals */}
      <Transition appear show={isOpenss} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeCardModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                  <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                    Delete
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Are you sure you want to delete this card?
                    </p>
                  </div>

                  <div className="mt-4 flex justify-center gap-4">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-full bg-[#FF6600] px-6 py-2 text-sm font-medium text-white shadow-md hover:bg-[#e65c00] transition-colors"
                      onClick={() => { handleDeleteCard(cardId.id); closeCardModal(); }}
                    >
                      Yes
                    </button>
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-full bg-gray-900 px-6 py-2 text-sm font-medium text-white shadow-md hover:bg-gray-800 transition-colors"
                      onClick={closeCardModal}
                    >
                      No
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      <Transition appear show={openMove} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeMoveModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center flex flex-col max-h-[80vh]">
                  <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900 mb-4">
                    Move To
                  </Dialog.Title>
                  <div className="flex flex-col flex-grow overflow-hidden">
                    <div className="relative rounded-lg border border-gray-300 flex-shrink-0">
                      <input
                        type="text"
                        placeholder="Search buckets"
                        value={searchBucket}
                        onChange={handleBucketInputChange}
                        className="w-full h-10 px-3 outline-none rounded-lg"
                      />
                      <span className="absolute right-3 top-2.5">
                        <FontAwesomeIcon icon={faSearch} className="text-gray-500" />
                      </span>
                    </div>
                    <div className="mt-2 w-full bg-white border rounded-lg overflow-y-auto flex-grow h-64 text-left custom-scrollbar">
                      <ul className="py-1">
                        {filteredBuckets?.map((option) => (
                          <li key={option._id} className="cursor-pointer hover:bg-gray-100">
                            <p className="px-4 py-2 text-sm text-gray-800" onClick={() => handleBucketChange(option)}>
                              {option.name}
                            </p>
                            {option.subBuckets?.length > 0 && (
                              <ul className="bg-gray-50">
                                {option.subBuckets.map((sub) => (
                                  <li key={sub._id}>
                                    <p className="px-8 py-1.5 text-xs text-gray-600 hover:bg-gray-200" onClick={() => handleSubBucketSelectChange(sub)}>
                                      -- {sub.name}
                                    </p>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="mt-6 flex justify-center gap-4 flex-shrink-0">
                      <button className="rounded-full bg-[#FF6600] px-8 py-2 text-white shadow-md hover:bg-[#e65c00] transition-colors" onClick={() => handleUpdateCardMenu(cardId.id)}>
                        Move
                      </button>
                      <button className="rounded-full bg-gray-900 px-8 py-2 text-white shadow-md hover:bg-gray-800 transition-colors" onClick={closeMoveModal}>
                        Cancel
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      <Transition appear show={openCopy} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeCopyModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center flex flex-col max-h-[80vh]">
                  <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900 mb-4">
                    Copy To
                  </Dialog.Title>
                  <div className="flex flex-col flex-grow overflow-hidden">
                    <div className="relative rounded-lg border border-gray-300 flex-shrink-0">
                      <input
                        type="text"
                        placeholder="Search buckets"
                        value={searchBucket}
                        onChange={handleBucketInputChange}
                        className="w-full h-10 px-3 outline-none rounded-lg"
                      />
                      <span className="absolute right-3 top-2.5">
                        <FontAwesomeIcon icon={faSearch} className="text-gray-500" />
                      </span>
                    </div>
                    <div className="mt-2 w-full bg-white border rounded-lg overflow-y-auto flex-grow h-64 text-left custom-scrollbar">
                      <ul className="py-1">
                        {filteredBuckets?.map((option) => (
                          <li key={option._id} className="cursor-pointer hover:bg-gray-100">
                            <p className="px-4 py-2 text-sm text-gray-800" onClick={() => handleBucketChange(option)}>
                              {option.name}
                            </p>
                            {option.subBuckets?.length > 0 && (
                              <ul className="bg-gray-50">
                                {option.subBuckets.map((sub) => (
                                  <li key={sub._id}>
                                    <p className="px-8 py-1.5 text-xs text-gray-600 hover:bg-gray-200" onClick={() => handleSubBucketSelectChange(sub)}>
                                      -- {sub.name}
                                    </p>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="mt-6 flex justify-center gap-4 flex-shrink-0">
                      <button className="rounded-full bg-[#FF6600] px-8 py-2 text-white shadow-md hover:bg-[#e65c00] transition-colors" onClick={() => handleUpdateCardMenu(cardId.id)}>
                        Copy
                      </button>
                      <button className="rounded-full bg-gray-900 px-8 py-2 text-white shadow-md hover:bg-gray-800 transition-colors" onClick={closeCopyModal}>
                        Cancel
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

    </div >
  );

}
export default CardDetail;
